//Job Ids
import { EAJL_UPPER, EAJL_THIRD } from '../data/jobID'

/**
 * @returns Max HP
 */
// export function HP(job, HpFactor, HpIncrease, baseLevel, Vit) {
export function HP(job, baseHp, baseLevel, Vit, HP_MOD_A, HP_MOD_B) {
	let BASE_HP = baseHp.BaseHp.find((bHp) => bHp.Level === baseLevel)?.Hp
	//set default value in case baseLevel is not ready yet after class change
	BASE_HP = BASE_HP ? BASE_HP : baseHp.BaseHp[0].Hp
	let TRANS_MOD = 1
	if (isRebirth(job)) TRANS_MOD = 1.25
	let MAX_HP = Math.floor(BASE_HP * TRANS_MOD)
	MAX_HP = Math.floor(MAX_HP * (1 + Vit * 0.01))
	MAX_HP += HP_MOD_A
	MAX_HP = Math.floor(MAX_HP * (1 + HP_MOD_B * 0.01))
	return Number(MAX_HP)
}

/**
 * @returns Max SP
 */
export function SP(job, baseSp, baseLevel, Int, SP_MOD_A, SP_MOD_B) {
	let BASE_SP = baseSp.BaseSp.find((bSp) => bSp.Level === baseLevel)?.Sp
	//set default value in case baseLevel is not ready yet after class change
	BASE_SP = BASE_SP ? BASE_SP : baseSp.BaseSp[0].Sp
	let TRANS_MOD = 1
	if (isRebirth(job)) TRANS_MOD = 1.25
	let MAX_SP = BASE_SP
	MAX_SP = Math.floor(MAX_SP * TRANS_MOD)
	MAX_SP = Math.floor(MAX_SP * (1 + Int * 0.01))
	MAX_SP += SP_MOD_A
	MAX_SP = Math.floor(MAX_SP * (1 + SP_MOD_B * 0.01))
	return Number(MAX_SP)
}

/**
 * @returns [ATKmin,ATKave,ATKMax]
 */
export function getBaseDamage(
	weapon,
	baseLevel,
	STR,
	DEX,
	LUK,
	ExtraATK,
	//MasteryATK,
	SizePenalty,
	Multipliers,
	applyElement,
) {
	let ATK = [0, 0, 0]
	let statusATK = 0
	let weaponATK = 0
	switch (weapon.SubType) {
		case 'Bow':
		case 'Musical':
		case 'Whip':
		case 'Revolver':
		case 'Rifle':
		case 'Gatling':
		case 'Shotgun':
		case 'Grenade':
			statusATK = StatusATK(baseLevel, DEX, STR, LUK)
			weaponATK = WeaponATK(weapon, DEX, SizePenalty / 100)
			break
		default:
			statusATK = StatusATK(baseLevel, STR, DEX, LUK)
			weaponATK = WeaponATK(weapon, STR, SizePenalty / 100)
			break
	}
	let groupAMultiplier = GroupAMultiplier(weaponATK, ExtraATK, Multipliers)
	let groupBMultiplier = GroupBMultiplier(weaponATK, ExtraATK, Multipliers)

	let PATK = 0
	let BuffATK = 0

	//ATK = {(StatusATK × 2) +
	//[(WeaponATK + ExtraATK) × Type2ATKMultiplier] +
	//[(WeaponATK + ExtraATK) × (1 + RaceMultiplier) × (1 + SizeMultiplier) × ...]} × (1 + P.ATK ÷ 100) + MasteryATK + BuffATK
	for (let i = 0; i <= 2; i++)
		ATK[i] = Math.floor(
			(2 * statusATK +
				(groupAMultiplier[i] + groupBMultiplier[i]) * applyElement) *
				(1 + PATK / 100) +
				//MasteryATK + //added in battleFormulas.js => getBattleDamage()
				BuffATK,
		)
	return ATK
}

/**
 * @returns GroupAMutiplier
 */
export function GroupAMultiplier(weaponATK, ExtraATK, Multipliers) {
	let Type2ATKMultiplier = Multipliers.ATKMultiplier / 100

	let GroupA = [0, 0, 0]
	for (let i = 0; i < 3; i++)
		GroupA[i] = Math.floor((weaponATK[i] + ExtraATK) * Type2ATKMultiplier)
	return GroupA
}

/**
 * @returns GroupBMutiplier
 */
export function GroupBMultiplier(weaponATK, ExtraATK, Multipliers) {
	let RaceMultiplier = Multipliers.RaceMultiplier / 100
	let SizeMultiplier = Multipliers.SizeMultiplier / 100
	let TargetPropertyMultiplier = Multipliers.TargetPropertyMultiplier / 100
	let MonsterMultiplier = Multipliers.MonsterMultiplier / 100
	let ClassMultiplier = Multipliers.ClassMultiplier / 100
	let PropertyMultiplier = Multipliers.PropertyMultiplier / 100
	let EDPMultiplier = Multipliers.EDPMultiplier

	let GroupB = [0, 0, 0]
	for (let i = 0; i < 3; i++)
		GroupB[i] =
			(weaponATK[i] + ExtraATK) *
			(1 + RaceMultiplier) *
			(1 + SizeMultiplier) *
			(1 + TargetPropertyMultiplier) *
			EDPMultiplier *
			(1 + MonsterMultiplier) *
			(1 + ClassMultiplier) *
			(1 + PropertyMultiplier)
	return GroupB
}
/**
 * @returns [WeaponATKmin,WeaponATKave,WeaponATKMax]
 */
export function WeaponATK(weapon, Stat, SizePenalty) {
	//WeaponATK = (BaseWeaponDamage + Variance + StatBonus + RefinementBonus + OverUpgradeBonus) × SizePenalty
	let BaseWeaponDamage = weapon.Attack
	let WeaponATK = [0, 0, 0]
	WeaponATK[0] = Math.floor(
		(weapon.Attack -
			VarianceATK(BaseWeaponDamage, weapon.WeaponLevel) +
			StatATKBonus(BaseWeaponDamage, Stat) +
			Refine(weapon.refine, weapon.WeaponLevel) +
			(OverUpgrade(weapon.refine, weapon.WeaponLevel) ? 1 : 0)) *
			(SizePenalty ? SizePenalty : 1),
	)
	WeaponATK[2] = Math.floor(
		(weapon.Attack +
			VarianceATK(BaseWeaponDamage, weapon.WeaponLevel) +
			StatATKBonus(BaseWeaponDamage, Stat) +
			Refine(weapon.refine, weapon.WeaponLevel) +
			OverUpgrade(weapon.refine, weapon.WeaponLevel)) *
			(SizePenalty ? SizePenalty : 1),
	)
	WeaponATK[1] = Math.floor((WeaponATK[0] + WeaponATK[2]) / 2)
	return WeaponATK
}

/**
 * @returns StatusATK
 */
export function StatusATK(baseLevel, STR, DEX, LUK) {
	// return (
	// 	Math.floor(baseLevel / 4) +
	// 	STR +
	// 	Math.floor(DEX / 5) +
	// 	Math.floor(LUK / 3)
	// )
	return Math.floor(baseLevel / 4 + STR + DEX / 5 + LUK / 3)
}
/**
 * @returns StatATKBonus
 * @Stat = Str or Dex with Bow, Gun, Instrument or Whip.
 */
export function StatATKBonus(BaseWeaponDamage, Stat) {
	return Math.floor((BaseWeaponDamage * Stat) / 200)
}
/**
 * @returns Variance for ATK
 */
export function VarianceATK(BaseWeaponDamage, WeaponLevel) {
	return Math.floor(0.05 * WeaponLevel * BaseWeaponDamage)
}

/**
 * @returns MATK
 */
export function getBaseMagicDamage(
	weapon,
	baseLevel,
	INT,
	DEX,
	LUK,
	ExtraMATK,
	applyElement,
) {
	let MATK = [0, 0, 0]
	let weaponMATK = WeaponMATK(weapon)

	for (let i = 0; i <= 2; i++)
		MATK[i] =
			(StatusMATK(baseLevel, INT, DEX, LUK) + weaponMATK[i]) *
				applyElement +
			ExtraMATK
	return MATK
}
/**
 * @returns StatusMATK
 */
export function StatusMATK(baseLevel, INT, DEX, LUK) {
	//StatusMATK = floor[floor[BaseLevel ÷ 4] + Int + floor[Int ÷ 2] + floor[Dex ÷ 5] + floor[Luk ÷ 3]]
	return (
		Math.floor(baseLevel / 4) +
		INT +
		Math.floor(INT / 2) +
		Math.floor(DEX / 5) +
		Math.floor(LUK / 3)
	)
}
/**
 * @returns Variance for MATK
 */
export function VarianceMATK(BaseWeaponDamage, WeaponLevel, refineLevel) {
	// return Math.floor(0.1 * WeaponLevel) * (BaseWeaponDamage + RefinementBonus)
	return (
		Math.floor(0.1 * WeaponLevel) *
		(BaseWeaponDamage + Refine(refineLevel, WeaponLevel))
	)
}
export function WeaponMATK(weapon) {
	//WeaponMATK = BaseWeaponDamage + Variance + RefinementBonus + OverUpgradeBonu
	let WeaponMATK = [0, 0, 0]

	WeaponMATK[0] =
		weapon.MagicAttack -
		VarianceMATK(weapon.MagicAttack, weapon.WeaponLevel, weapon.refine) +
		Refine(weapon.refine, weapon.WeaponLevel) +
		OverUpgrade(weapon.refine, weapon.WeaponLevel)
			? 1
			: 0
	WeaponMATK[2] =
		weapon.MagicAttack +
		VarianceMATK(weapon.MagicAttack, weapon.WeaponLevel, weapon.refine) +
		Refine(weapon.refine, weapon.WeaponLevel) +
		OverUpgrade(weapon.refine, weapon.WeaponLevel)
	WeaponMATK[1] = Math.floor((WeaponMATK[0] + WeaponMATK[2]) / 2)

	return WeaponMATK
}

/**
 * @returns ATK/MATK from refine
 */
export function Refine(refineLevel, WeaponLevel) {
	let refineBonus = 2
	if (WeaponLevel === 2) refineBonus = 3
	if (WeaponLevel === 3) refineBonus = 5
	if (WeaponLevel === 4) refineBonus = 7
	if (WeaponLevel === 5) refineBonus = 8

	return refineLevel * refineBonus
}

/**
 * @returns ATK/MATK  from over refine
 */
export function OverUpgrade(refineLevel, WeaponLevel) {
	let refineBonus = 3
	let subRefine = 7
	if (WeaponLevel === 2) {
		refineBonus = 5
		subRefine = 6
	}
	if (WeaponLevel === 3) {
		refineBonus = 8
		subRefine = 5
	}
	if (WeaponLevel === 4) {
		refineBonus = 14
		subRefine = 4
	}
	if (WeaponLevel === 5) {
		refineBonus = 0
		subRefine = 0
	}

	return (
		// Math.max(Math.min(refineLevel, 15) - subRefine, 0) * refineBonus +
		Math.max(refineLevel - subRefine, 0) * refineBonus +
		HighUpgrade(refineLevel, WeaponLevel)
	)
}
/**
 * @returns ATK/MATK  from High Upgrade
 */
export function HighUpgrade(refineLevel, WeaponLevel) {
	let refineBonus = 1
	let overBonus = 16
	if (WeaponLevel === 2) {
		refineBonus = 2
		overBonus = 32
	}
	if (WeaponLevel === 3) {
		refineBonus = 2
		overBonus = 32
	}
	if (WeaponLevel === 4) {
		refineBonus = 3
		overBonus = 48
	}
	if (WeaponLevel === 5) {
		refineBonus = 0
		overBonus = 0
	}
	return refineLevel > 15 ? overBonus + (refineLevel - 16) * refineBonus : 0
}

/**
 * @returns DEF
 */
export function DEF(
	headtop,
	headMid,
	headLow,
	body,
	rightHand,
	leftHand,
	garment,
	shoes,
	rightAccessory,
	leftAccessory,
	bDef,
	bDefRate,
) {
	let TotalDef = bDef
	TotalDef += headtop.Defense ? headtop.Defense : 0
	TotalDef += headMid.Defense ? headMid.Defense : 0
	TotalDef += headLow.Defense ? headLow.Defense : 0
	TotalDef += body.Defense ? body.Defense : 0
	TotalDef += rightHand.Defense ? rightHand.Defense : 0
	TotalDef += leftHand.Defense ? leftHand.Defense : 0
	TotalDef += garment.Defense ? garment.Defense : 0
	TotalDef += shoes.Defense ? shoes.Defense : 0
	TotalDef += rightAccessory.Defense ? rightAccessory.Defense : 0
	TotalDef += leftAccessory.Defense ? leftAccessory.Defense : 0
	//refine
	TotalDef += calcRefineDEF(headtop.refine)
	TotalDef += calcRefineDEF(body.refine)
	if (leftHand.Type === 'Armor') TotalDef += calcRefineDEF(leftHand.refine)
	TotalDef += calcRefineDEF(garment.refine)
	TotalDef += calcRefineDEF(shoes.refine)
	TotalDef += Math.floor(TotalDef * (bDefRate / 100))

	return TotalDef
}

/**
 * @returns DEF from Refine
 */
function calcRefineDEF(refineLevel) {
	// Every +1 upgrade at +1 ~ +4 increases Hard DEF by 1.
	// Every +1 upgrade at +5 ~ +8 increases Hard DEF by 2.
	// Every +1 upgrade at +9 ~ +12 increases Hard DEF by 3.
	// Every +1 upgrade at +13 ~ +16 increases Hard DEF by 4.
	// Every +1 upgrade at +17 ~ +20 increases Hard DEF by 5.
	let DEF = 0
	if (refineLevel <= 4) DEF = refineLevel * 1
	else if (refineLevel <= 8) DEF = 4 + (refineLevel - 4) * 2
	else if (refineLevel <= 12) DEF = 12 + (refineLevel - 8) * 3
	else if (refineLevel <= 16) DEF = 24 + (refineLevel - 12) * 4
	else if (refineLevel <= 20) DEF = 40 + (refineLevel - 16) * 5
	return DEF
}

/**
 * @returns Soft DEF
 */
export function SoftDEF(VIT, AGI, baseLevel, BonusA, BonusB) {
	// let BonusA = 0
	// let BonusB = 0
	let SoftDEF = Math.floor(VIT / 2 + AGI / 5 + baseLevel / 2)
	// let TotalSoftDEF = [(SoftDEF + BonusA) * (1 + BonusB / 100)]
	return Math.floor((SoftDEF + BonusA) * (1 + BonusB / 100))
}

/**
 * @returns MDEF
 * @TODO
 */
export function MDEF() {
	//TODO
	let MDEF = 0
	return MDEF
}

/**
 * @returns Soft MDEF
 */
export function SoftMDEF(INT, VIT, DEX, baseLevel, BonusA, BonusB) {
	let SoftMDEF = Math.floor(INT + VIT / 5 + DEX / 5 + baseLevel / 4)
	return Math.floor((SoftMDEF + BonusA) * (1 + BonusB / 100))
}

/**
 * @returns HIT
 */
export function HIT(baseLevel, DEX, LUK, BonusA, BonusB) {
	let HIT = 175 + baseLevel + DEX + Math.floor(LUK / 3) + BonusA
	return Math.floor(HIT * (1 + BonusB / 100))
}

/**
 * @returns Flee
 */
export function FLEE(baseLevel, AGI, LUK, BonusA, BonusB) {
	return Math.floor(
		(100 + baseLevel + AGI + Math.floor(LUK / 5) + BonusA) *
			(1 + BonusB / 100),
	)
}

/**
 * @returns Perfect Dodge
 */
export function PerfectDodge(LUK, BonusA, BonusB) {
	return Math.floor((1 + Math.floor(LUK / 10) + BonusA) * (1 + BonusB / 100))
}

/**
 * @returns Critical rate
 */
export function CritRate(LUK, BonusA, BonusB) {
	return Math.floor((1 + Math.floor(LUK / 3) + BonusA) * (1 + BonusB / 100))
}

/**
 * @returns ASPD
 */
export function ASPD(jobASPD, rightHand, leftHand, AGI, DEX, bAspd, bAspdRate) {
	//TODO
	let sc = 0
	let bl = 0
	let amotion = 0
	// let skill_lv = 0
	let val = 0
	let temp_aspd = 0

	// 	amotion = job->aspd_base[sd->weapontype1]; // Single weapon
	if (jobASPD)
		amotion =
			jobASPD.BaseASPD[rightHand.SubType ? rightHand.SubType : 'Fist'] //TODO -> Change Weapon

	// 	if (sd->status.shield)
	// 		amotion += job->aspd_base[MAX_WEAPON_TYPE];
	// 	else if (sd->weapontype2 != W_FIST && sd->equip_index[EQI_HAND_R] != sd->equip_index[EQI_HAND_L])
	// 		amotion += job->aspd_base[sd->weapontype2] / 4; // Dual-wield
	if (leftHand.Type === 'Armor') {
		amotion += jobASPD.BaseASPD['Shield']
	} else if ((leftHand.SubType ? leftHand.SubType : 'Fist') !== 'Fist') {
		amotion += jobASPD.BaseASPD[leftHand.SubType] / 4
	}

	// 	switch(sd->status.weapon) {
	// 		case W_BOW:
	// 		case W_MUSICAL:
	// 		case W_WHIP:
	// 		case W_REVOLVER:
	// 		case W_RIFLE:
	// 		case W_GATLING:
	// 		case W_SHOTGUN:
	// 		case W_GRENADE:
	// 			temp_aspd = status->dex * status->dex / 7.0f + status->agi * status->agi * 0.5f;
	// 			break;
	// 		default:
	// 			temp_aspd = status->dex * status->dex / 5.0f + status->agi * status->agi * 0.5f;
	// 			break;
	// 	}
	switch (rightHand.SubType) {
		case 'Bow':
		case 'Musical':
		case 'Whip':
		case 'Revolver':
		case 'Rifle':
		case 'Gatling':
		case 'Shotgun':
		case 'Grenade':
			temp_aspd = (DEX * DEX) / 7.0 + AGI * AGI * 0.5
			break
		default:
			temp_aspd = (DEX * DEX) / 5.0 + AGI * AGI * 0.5
			break
	}

	// 	temp_aspd = (float)(sqrt(temp_aspd) * 0.25f) + 0xc4;
	temp_aspd = Math.sqrt(temp_aspd) * 0.25 + 0xc4
	// 	if ((skill_lv = pc_checkskill(sd,SA_ADVANCEDBOOK)) > 0 && sd->status.weapon == W_BOOK)
	// 		val += (skill_lv - 1) / 2 + 1;
	// 	if ((skill_lv = pc_checkskill(sd, SG_DEVIL)) > 0 && ((sd->class_&MAPID_THIRDMASK) == MAPID_STAR_EMPEROR || pc_is_maxjoblv(sd)))
	// 		val += 1 + skill_lv;
	// 	if ((skill_lv = pc_checkskill(sd,GS_SINGLEACTION)) > 0 && (sd->status.weapon >= W_REVOLVER && sd->status.weapon <= W_GRENADE))
	// 		val += ((skill_lv + 1) / 2);
	// 	if (pc_isriding(sd))
	// 		val -= 50 - 10 * pc_checkskill(sd, KN_CAVALIERMASTERY);
	// 	else if (pc_isridingdragon(sd))
	// 		val -= 25 - 5 * pc_checkskill(sd, RK_DRAGONTRAINING);
	// 	amotion = ((int)(temp_aspd + ((float)(status_calc_aspd(&sd->bl, &sd->sc, true) + val) * status->agi / 200)) - min(amotion, 200));
	// console.log(amotion)
	amotion =
		temp_aspd +
		((status_calc_aspd(bl, sc, true) + val) * AGI) / 200 -
		Math.min(amotion, 200)
	// console.log(amotion)

	// // RE ASPD % modifier
	// amotion += (max(0xc3 - amotion, 2) * (status->aspd_rate2 + status_calc_aspd(bl, sc, false))) / 100;
	// amotion = 10 * (200 - amotion);
	// amotion += sd->bonus.aspd_add;
	// amotion = status_calc_fix_aspd(bl, sc, amotion);
	// status->amotion = cap_value(amotion,pc_maxaspd(sd),2000);
	// //Attack delai with skills
	// status->adelay = 2 * status->amotion;

	amotion += (193 - amotion) * (bAspdRate / 100)
	// amotion += bAspd

	return Number(amotion).toFixed(2)
}
/**
 *
 * @returns bonus ASPD from skills
 * @TODO
 */
function status_calc_aspd(/* bl, sc, fixed */) {
	// Rathena formula :
	// 	int bonus = 0;
	// 	if (!sc || !sc->count)
	return 0
	// 	if (fixed) {
	// 		enum sc_type sc_val;
	// 		if (!sc->getSCE(SC_QUAGMIRE)) {
	// 			// !TODO: How does Two-Hand Quicken, Adrenaline Rush, and Spear quick change? (+10%)
	// 			if (bonus < 7 && (sc->getSCE(SC_TWOHANDQUICKEN) || sc->getSCE(SC_ONEHAND) || sc->getSCE(SC_MERC_QUICKEN) || sc->getSCE(SC_ADRENALINE) || sc->getSCE(SC_SPEARQUICKEN)))
	// 				bonus = 7;
	// 			else if (bonus < 6 && sc->getSCE(SC_ADRENALINE2))
	// 				bonus = 6;
	// 			else if (bonus < 5 && sc->getSCE(SC_FLEET))
	// 				bonus = 5;
	// 		}
	// 		if (sc->getSCE(SC_ASSNCROS) && bonus < sc->getSCE(SC_ASSNCROS)->val2) {
	// #ifdef RENEWAL
	// 			bonus += sc->getSCE(SC_ASSNCROS)->val2;
	// 		}
	// 		if (bonus < 20 && sc->getSCE(SC_MADNESSCANCEL))
	// 			bonus = 20;
	// 		else if (bonus < 15 && sc->getSCE(SC_BERSERK))
	// 			bonus = 15;
	// 		if (sc->getSCE(sc_val = SC_ASPDPOTION3) || sc->getSCE(sc_val = SC_ASPDPOTION2) || sc->getSCE(sc_val = SC_ASPDPOTION1) || sc->getSCE(sc_val = SC_ASPDPOTION0))
	// 			bonus += sc->getSCE(sc_val)->val1;
	// 		if (sc->getSCE(SC_ATTHASTE_CASH))
	// 			bonus += sc->getSCE(SC_ATTHASTE_CASH)->val1;
	// 	} else {
	// 		if (sc->getSCE(SC_DONTFORGETME))
	// 			bonus -= sc->getSCE(SC_DONTFORGETME)->val2 / 10;
	// #ifdef RENEWAL
	// 		if (sc->getSCE(SC_ENSEMBLEFATIGUE))
	// 			bonus -= sc->getSCE(SC_ENSEMBLEFATIGUE)->val2 / 10;
	// #endif
	// 		if (sc->getSCE(SC_STEELBODY))
	// 			bonus -= 25;
	// 		if (sc->getSCE(SC_SKA))
	// 			bonus -= 25;
	// 		if (sc->getSCE(SC_DEFENDER))
	// 			bonus -= sc->getSCE(SC_DEFENDER)->val4 / 10;
	// 		if (sc->getSCE(SC_GOSPEL) && sc->getSCE(SC_GOSPEL)->val4 == BCT_ENEMY)
	// 			bonus -= 75;
	// #endif
	// 		if (sc->getSCE(SC_JOINTBEAT)) { // Needs more info
	// 			if (sc->getSCE(SC_JOINTBEAT)->val2&BREAK_WRIST)
	// 				bonus -= 25;
	// 			if (sc->getSCE(SC_JOINTBEAT)->val2&BREAK_KNEE)
	// 				bonus -= 10;
	// 		}
	// 		if (sc->getSCE(SC_FREEZING))
	// 			bonus -= 30;
	// 		if (sc->getSCE(SC_HALLUCINATIONWALK_POSTDELAY))
	// 			bonus -= 50;
	// 		if (sc->getSCE(SC_PARALYSE) && sc->getSCE(SC_PARALYSE)->val3 == 1)
	// 			bonus -= 10;
	// 		if (sc->getSCE(SC__BODYPAINT))
	// 			bonus -= 5 * sc->getSCE(SC__BODYPAINT)->val1;
	// 		if (sc->getSCE(SC__INVISIBILITY))
	// 			bonus -= sc->getSCE(SC__INVISIBILITY)->val2;
	// 		if (sc->getSCE(SC__GROOMY))
	// 			bonus -= sc->getSCE(SC__GROOMY)->val2;
	// 		if (sc->getSCE(SC_SWINGDANCE))
	// 			bonus += sc->getSCE(SC_SWINGDANCE)->val3;
	// 		if (sc->getSCE(SC_DANCEWITHWUG))
	// 			bonus += sc->getSCE(SC_DANCEWITHWUG)->val3;
	// 		if (sc->getSCE(SC_GLOOMYDAY))
	// 			bonus -= sc->getSCE(SC_GLOOMYDAY)->val3;
	// 		if (sc->getSCE(SC_GT_CHANGE))
	// 			bonus += sc->getSCE(SC_GT_CHANGE)->val3;
	// 		if (sc->getSCE(SC_MELON_BOMB))
	// 			bonus -= sc->getSCE(SC_MELON_BOMB)->val3;
	// 		if (sc->getSCE(SC_BOOST500))
	// 			bonus += sc->getSCE(SC_BOOST500)->val1;
	// 		if (sc->getSCE(SC_EXTRACT_SALAMINE_JUICE))
	// 			bonus += sc->getSCE(SC_EXTRACT_SALAMINE_JUICE)->val1;
	// 		if (sc->getSCE(SC_GOLDENE_FERSE))
	// 			bonus += sc->getSCE(SC_GOLDENE_FERSE)->val3;
	// 		if (sc->getSCE(SC_INCASPDRATE))
	// 			bonus += sc->getSCE(SC_INCASPDRATE)->val1;
	// 		if (sc->getSCE(SC_GATLINGFEVER))
	// 			bonus += sc->getSCE(SC_GATLINGFEVER)->val1;
	// 		if (sc->getSCE(SC_STAR_COMFORT))
	// 			bonus += 3 * sc->getSCE(SC_STAR_COMFORT)->val1;
	// 		if (sc->getSCE(SC_WIND_INSIGNIA) && sc->getSCE(SC_WIND_INSIGNIA)->val1 == 2)
	// 			bonus += 10;
	// 		if (sc->getSCE(SC_INCREASEAGI))
	// 			bonus += sc->getSCE(SC_INCREASEAGI)->val1;
	// 		if (sc->getSCE(SC_NIBELUNGEN) && sc->getSCE(SC_NIBELUNGEN)->val2 == RINGNBL_ASPDRATE)
	// 			bonus += 20;
	// 		if (sc->getSCE(SC_STARSTANCE))
	// 			bonus += sc->getSCE(SC_STARSTANCE)->val2;
	// 		if( sc->getSCE(SC_2011RWC_SCROLL) )
	// 			bonus += 5;
	// 		if( sc->getSCE(SC_SPARKCANDY) )
	// 			bonus += 25;
	// 		if( sc->getSCE(SC_ACARAJE) )
	// 			bonus += 10;
	// 		if( sc->getSCE(SC_SKF_ASPD) )
	// 			bonus += sc->getSCE(SC_SKF_ASPD)->val1;
	// 		if( sc->getSCE(SC_PORK_RIB_STEW) )
	// 			bonus += 5;
	// 		map_session_data* sd = BL_CAST(BL_PC, bl);
	// 		uint8 skill_lv;
	// 		if (sd) {
	// 			if ((skill_lv = pc_checkskill(sd, BA_MUSICALLESSON)) > 0)
	// 				bonus += skill_lv;
	// 			if ((skill_lv = pc_checkskill(sd, RG_PLAGIARISM)) > 0)
	// 				bonus += skill_lv;
	// 		}
	// 	}
	// 	return bonus;
}

export function isRebirth(jobID) {
	return Boolean(jobID & EAJL_UPPER)
}
export function isThird(jobID) {
	return Boolean(jobID & EAJL_THIRD)
}
export function getDefReduction(DEF) {
	return (4000 + DEF) / (4000 + DEF * 10)
}
